import { Navigate } from "react-router-dom";
import { getUserRole } from "./roleCrypto";

const ProtectedRoute = ({ children }) => {
  const userRole = getUserRole();

  if (!userRole) {
    return <Navigate to="/login" replace />;
  }

  // block subadmin routes
  if (
    userRole === "subadmin" &&
    (window.location.pathname === "/expenses" ||
      window.location.pathname === "/setting")
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;